import { Chip, ChipProps } from '@mui/material';
import { TenantStatusTypes } from 'TenantModule/constants';
import { DataCellProps } from '../types';

// Badge colors follow the Teams status badge treatment (TeamsV2StatusCell)
const statusColors: Record<TenantStatusTypes, ChipProps['color']> = {
  [TenantStatusTypes.Ready]: 'success',
  // Warning, not success: mock-verified, the tenant's own infra was never checked.
  [TenantStatusTypes.MockReady]: 'warning',
  [TenantStatusTypes.Creating]: 'warning',
  [TenantStatusTypes.AwaitingInfrastructure]: 'info',
  [TenantStatusTypes.CreationFailed]: 'error',
  [TenantStatusTypes.Archived]: 'default',
  [TenantStatusTypes.PartiallyRemoved]: 'error',
  [TenantStatusTypes.Decommissioned]: 'default',
};

export const TenantStatusCell = ({ _customRowProps, tenant }: DataCellProps) => {
  if (!tenant.status) return <div />;

  return (
    <Chip
      label={tenant.status}
      size="small"
      color={statusColors[tenant.status] || 'default'}
      sx={{ fontWeight: 500 }}
    />
  );
};
